import { render, staticRenderFns } from "./SmsConsentAlert.vue?vue&type=template&id=fe3542d4&scoped=true"
var script = {}
import style0 from "./SmsConsentAlert.vue?vue&type=style&index=0&id=fe3542d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3542d4",
  null
  
)

export default component.exports